<template>
  <Teleport to="body">
    <Transition name="overlay">
      <div
        v-if="visible"
        :class="['tir-pm-drawer__overlay', overlayClass]"
        @click="close"
      />
    </Transition>
    <Transition name="panel">
      <div
        v-if="visible"
        class="tir-pm-drawer__panel"
        :class="[`position--${position}`, panelClass]"
        :style="style"
      >
        <slot name="content" :close="close">
          <div class="tir-pm-drawer__panel-content">
            <TirPmScrollbar style="height: 100%; max-height: 100%">
              <div class="tir-pm-drawer__panel-content-inner">
                <slot :close="close" />
              </div>
            </TirPmScrollbar>
          </div>
        </slot>
      </div>
    </Transition>
  </Teleport>
</template>

<script lang="ts" setup>
import { computed, CSSProperties } from "vue";
import { TirPmDrawerPositionEnum } from "./enums";
import { TirPmScrollbar } from "tir-pm-scrollbar";

const emit = defineEmits<{
  /**Событие обновления видимости */
  (e: "update:visible", value: boolean): void;
}>();

const props = withDefaults(
  defineProps<{
    /**Видимость */
    visible?: boolean;
    /**Размер */
    size?: string;
    /**Позиция */
    position?: TirPmDrawerPositionEnum;
    /**Класс для оверлея */
    overlayClass?: string;
    /**Класс для панели */
    panelClass?: string;
  }>(),
  {
    visible: false,
    size: "auto",
    position: TirPmDrawerPositionEnum.Left,
    overlayClass: "",
    panelClass: "",
  }
);

const style = computed<CSSProperties>(() => {
  const isHorizontal = [
    TirPmDrawerPositionEnum.Top,
    TirPmDrawerPositionEnum.Bottom,
  ].includes(props.position);

  const isVertical = [
    TirPmDrawerPositionEnum.Left,
    TirPmDrawerPositionEnum.Right,
  ];

  return {
    width: isVertical ? props.size : "",
    height: isHorizontal ? props.size : "",
  };
});

const close = () => {
  emit("update:visible", false);
};
</script>
<style lang="scss">
@use "sass:map";
@import "tir-style-system/expose-variables";
@import "tir-style-system/expose-default-theme";
@import "tir-style-system/core/mixins";

:root {
  --tir-pm-drawer__overlay-bg: rgba(0, 0, 0, 0.4);
  --tir-pm-drawer__panel-bg: var(--bg-base, #fff);
}
</style>
<style lang="scss" scoped>
.tir-pm-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;

  &__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: var(--tir-pm-drawer__overlay-bg);
    z-index: 1000;
  }
  &__panel-content {
    height: 100%;
  }
  &__panel-content-inner {
    padding: 1.75rem;
  }

  &__panel {
    position: fixed;
    z-index: 1001;
    background-color: var(--tir-pm-drawer__panel-bg);

    &.position--left {
      top: 0;
      bottom: 0;
      left: 0;
      height: 100vh;
    }
    &.position--right {
      top: 0;
      bottom: 0;
      right: 0;
      height: 100vh;
    }

    &.position--top {
      top: 0;
      left: 0;
      right: 0;
      width: 100vw;
    }
    &.position--top {
      top: 0;
      left: 0;
      right: 0;
      width: 100vw;
    }
    &.position--bottom {
      bottom: 0;
      left: 0;
      right: 0;
      width: 100vw;
    }

    &.position--full {
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
    }
  }
}

.overlay-enter-active,
.overlay-leave-active {
  transition: opacity 0.2s ease;
}

.overlay-enter-from,
.overlay-leave-to {
  opacity: 0;
}

.panel-enter-active,
.panel-leave-active {
  transition: transform 0.3s ease, opacity 0.2s ease;
}

.panel-enter-from,
.panel-leave-to {
  &.position--left {
    transform: translateX(-100%);
  }
  &.position--right {
    transform: translateX(100%);
  }
  &.position--bottom {
    transform: translateY(100%);
  }
  &.position--top {
    transform: translateY(-100%);
  }

  opacity: 0;
}
</style>
